import { FlowArrow } from '@phosphor-icons/react';

export default FlowArrow;
